import { render } from "./Cursor.vue?vue&type=template&id=81717e8c"
import script from "./Cursor.vue?vue&type=script&lang=js"
export * from "./Cursor.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__